// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1QGpc","upload":"Small_upload__T172i","imageWrap":"Small_imageWrap__2mx9Y","removeBtn":"Small_removeBtn__3S5NJ"};